import { Spinner as BootstrapSpinner } from 'react-bootstrap';

export const Spinner = () => (
    <div className="m-3 text-center">
        <BootstrapSpinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
        </BootstrapSpinner>
    </div>
);